const blogBasePath = '/blog'

const femRoutes = {
  home: '/',
  personalBanking: '/personal-banking',
  about: '/about',
  datePicker: '/public/date-picker',
  ecomLp: '/e',
  api: '/api',
  bankAccounts: '/bank-accounts',
  contact: '/contact',
  credit: '/credit',
  treasuryContact: '/contact/treasury',
  contactPartnerships: '/contact/partnerships',
  contactSales: '/contact/sales',
  ecommerce: '/ecommerce',
  faq: '/faq',
  financialWorkflows: '/financial-workflows',
  accountingAutomations: '/accounting-automations',
  blogHomepage: blogBasePath,
  blogIndex: `${blogBasePath}/search`,
  blogTag: (tag: string) => `${blogBasePath}/search?tags=${tag}`,
  blogArticle: (articleSlug: string) => `${blogBasePath}/${articleSlug}`,
  blogAuthor: (authorSlug: string) => `${blogBasePath}/authors/${authorSlug}`,
  blogCategory: (categorySlug: string) =>
    `${blogBasePath}/categories/${categorySlug}`,
  blogTopic: (topicSlug: string) => `${blogBasePath}/topics/${topicSlug}`,
  billPay: '/bill-pay',
  howItWorks: '/how-mercury-works',
  investorIndex: '/investor-database',
  investorDetails: (investorCallsign: string) =>
    `/investor-database/${investorCallsign}`,
  investorFundDetails: (fundCallsign: string) =>
    `/investor-database/fund/${fundCallsign}`,
  jobs: '/jobs',
  job: (job: string): string => `/jobs/${job}`,
  legalIndex: '/legal',
  legalPage: (slug: string): string => `/legal/${slug}`,
  lifeScience: '/life-science',
  northstar: '/northstar',
  partnerships: '/partnerships',
  perks: '/perks',
  perksDetails: (slug: string) => `/perks/${slug}`,
  pricing: '/pricing',
  raise: '/raise',
  raiseFounderCommunity: '/raise/founder-community',
  raiseInvestorConnect: '/raise/investor-connect',
  safe: '/safe',
  softwareStackIndex: '/raise/software-stack',
  softwareStackCategory: (categoryId: string) =>
    `/raise/software-stack/categories/${categoryId}`,
  softwareStackTool: (toolId: string) => `/raise/software-stack/tools/${toolId}`,
  saas: '/saas',
  security: '/security',
  spheresUpdatesForm: '/spheres/subscribe',
  treasury: '/treasury',
  vcFunds: '/vc-funds',
  ventureDebt: '/venture-debt',
  web3: '/web3',
  ycInterviews: '/ycmocks',
} as const

const legalRoutes = {
  choice: '/legal/choice',
  column: '/legal/column',
  evolve: '/legal/evolve',
  customerPerksDisclosure: '/legal/terms#5-promotional-offers-and-perks',
  privacy: '/legal/privacy',
  terms: '/legal/terms',
} as const

export const internalLinks = {
  ...femRoutes,
  legal: legalRoutes,
} as const
